import {View} from 'native-base';

import PanelLoader from 'components/PanelContainer/PanelLoader';

const FullPageLoader = () => {
  return (
    <View
      flex={1}
      alignItems="center"
      justifyContent="center"
      minH="100vh"
      w="100%"
      bgColor="#F7F7F8"
      style={{
        shadowColor: '#000',
        shadowOffset: {
          width: 0,
          height: 4,
        },
        shadowOpacity: 0.1,
        shadowRadius: 6.0,
      }}
    >
      <PanelLoader />;
    </View>
  );
};

export default FullPageLoader;
